import classnames from "classnames/bind";
import styles from './TopMenu.module.scss';
import {
    LoginOutlined,
    SecurityScanOutlined,
    UserOutlined
} from "@ant-design/icons";
import {Avatar, Dropdown} from "antd";
import {useContext} from "react";
import ItemDropDown from "./ItemDropDown/ItemDropDown";
import {useNavigate} from "react-router-dom";
import {redirectAuth} from "../../../app/routes";
import { logout } from "../../../features/auth/api";
import LoadingContext from "../../../app/contexts/LoadingContext";
import useAuth from "../../../shared/hooks/useAuth";
const cx = classnames.bind(styles);
function TopMenu({balance}) {
    const { signOut } = useAuth();
    const navigate  = useNavigate();
    const {setLoading} = useContext(LoadingContext);
    const handleSignOut = async () => {
        setLoading(true);
        try {
            // Gọi API logout trước
            const response = await logout();
            if (response.success) {
                signOut();
                navigate(redirectAuth);
            }
        } catch (error) {
            console.error('Logout error:', error);
            // Vẫn đăng xuất local nếu API thất bại
            signOut();
            navigate(redirectAuth);
        }
        setLoading(false);
    }
    const items = [
        {
            key: 'profile',
            label: (
                <ItemDropDown icon={<UserOutlined/>} to={'/user/profile'}>Trang cá nhân</ItemDropDown>
            ),
        },
        {
            key: 'security',
            label: (
                <ItemDropDown icon={<SecurityScanOutlined/>} to={'/user/security'}>Bảo mật</ItemDropDown>
            ),
        },
        {
            key: 'logout',
            label: (
                <ItemDropDown onClick={handleSignOut} icon={<LoginOutlined/>}>Đăng xuất</ItemDropDown>
            )
        }
    ];
    return (
        <div
            className={cx('wrapper')}
        >
            <div
                className={cx('icon')}
            >
                <Dropdown
                    placement={'bottomRight'}
                    arrow={{
                        pointAtCenter: true,
                    }}
                    menu={{
                        items
                    }}
                >
                    <Avatar size={'default'} icon={<UserOutlined />} />
                </Dropdown>
            </div>
        </div>
    )
}
export default TopMenu;